import { BaseModel } from '../../_base/crud';
import { Address } from './address.model';

export class Drawing extends BaseModel {
  uuid: string;
  projectId: string;
  nodeDataArrayJSON: string;
  depthoption: {component: number, busbar: number, total: number};

  clear(): void {
    this.uuid = '';
    this.nodeDataArrayJSON = '';
    this.depthoption = {component: undefined, busbar: undefined, total: undefined};
    this.projectId = '';
  }
}
